export default "__VITE_ASSET__Dw$U9GNa__"